import { API_URL } from './Constants';
import ApiService from './ApiService';
import { EditorState } from 'draft-js';
import { convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';

class ThongBaoPageApi {
    // --------------- ADMIN -----------------
    static submitPost = async (formData) => {
        const data = new FormData();
        data.append("title", formData.title);
        data.append("description", formData.description);
        data.append("content", formData.content);
        data.append("seoUrl", formData.seoUrl);
        data.append("active", formData.active);
        data.append("isNew", formData.isNew);
        data.append("isHot", formData.isHot);
        data.append("isHome", formData.isHome);
        data.append("isSlide", formData.isSlide);

        try {
            if(formData.content) {
                const rawContent = convertToRaw(formData.content.getCurrentContent());  // Get raw content
                const htmlContent = draftToHtml(rawContent);  // Convert to HTML
                data.append("content", htmlContent); // Assuming it's a string
            }

            const response = await ApiService.postFormData(API_URL + "/thong-bao/create", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    static updatePost = async (formData) => {
        const data = new FormData();
        data.append("postId", formData.postId);
        data.append("title", formData.title);
        data.append("description", formData.description);
        data.append("seoUrl", formData.seoUrl);
        data.append("active", formData.active);
        data.append("isNew", formData.isNew);
        data.append("isHot", formData.isHot);
        data.append("isHome", formData.isHome);
        data.append("isSlide", formData.isSlide);

        try {
            if(formData.content) {
                const rawContent = convertToRaw(formData.content.getCurrentContent());  // Get raw content
                const htmlContent = draftToHtml(rawContent);  // Convert to HTML
                data.append("content", htmlContent); // Assuming it's a string
            }
            const response = await ApiService.postFormData(API_URL + "/thong-bao/update", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    static getChiTietThongbaoAdmin = async (postId, postType) => {
        try {
            let params = { postId, postType };

            console.log(params)

            return await ApiService.getDataWithParams(API_URL + "/thong-bao/detail", params);
        } catch (error) {
        }
    };
}

export default ThongBaoPageApi;